// Global constants for Where's Junior
export const CONTACT_EMAIL = 'imagine@dozesq.com';
export const SUPPORT_EMAIL = 'imagine@dozesq.com';
export const PRIVACY_EMAIL = 'imagine@dozesq.com';
export const APP_NAME = "Where's Junior";
export const FOUNDATION_NAME = 'Jeffrey Lucas Gurmendi Marshall Foundation';
export const EFFECTIVE_DATE = 'November 18, 2025'; // Update as needed